import { CalendarClock } from "lucide-react";
import { MaskLine, Reveal } from "../components/Motion";
import { PlanningModule } from "../components/PlanningModule";

export default function Afspraak() {
  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-primary mb-4 flex items-center gap-2">
          <CalendarClock size={15} /> Werkplaats
        </p>
        <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl leading-none text-text-main">
          <MaskLine>Afspraak</MaskLine>
          <MaskLine delay={0.12}><span className="text-primary">maken</span></MaskLine>
        </h1>
        <p className="mt-6 text-text-muted max-w-xl text-lg leading-relaxed">
          Plan eenvoudig en snel online een afspraak voor onderhoud, APK of reparatie. Kies een datum en tijd die u het beste uitkomt.
        </p>

        <Reveal delay={0.1}>
          <div className="mt-12 bg-surface border border-border p-4 sm:p-8">
            <PlanningModule />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
